'use client';

import { useState, useEffect } from 'react';

export type DeviceType = 'ios' | 'android' | 'desktop';

/**
 * Hook to detect the user's device type
 * @returns DeviceType - 'ios', 'android', or 'desktop'
 */
export function useDevice(): DeviceType {
  const [device, setDevice] = useState<DeviceType>('desktop');

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const userAgent = window.navigator.userAgent.toLowerCase();

    // Check for iOS
    const isIOS =
      /iphone|ipad|ipod/.test(userAgent) ||
      (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);

    // Check for Android
    const isAndroid = /android/.test(userAgent);

    if (isIOS) {
      setDevice('ios');
    } else if (isAndroid) {
      setDevice('android');
    } else {
      setDevice('desktop');
    }
  }, []);

  return device;
}
